<template>
  <div class="inner" v-if="isMobile">
    <div v-for="(unit, unitIndex) in currentLevelJson.units">
      <!-- ユニットタイトル -->
      <h3 v-if="unitIndex == 0" class="h3 active" :id="UnitIndexs[unitIndex]">ユニット{{ fixedUnitNo }} 「{{ fixedUnitTitle }}」</h3>
      <h3 v-else class="h3" :id="UnitIndexs[unitIndex]">ユニット{{ unit.unitNo }} 「{{ unit.title }}」</h3>

      <!-- ユニット詳細一覧 -->
      <div class="flexbox">
        <div v-for="(lesson, lessonIndex) in unit.lessons" class="item" :id="LessonIndexs[unitIndex][lessonIndex]">
          <popover class="section" name="unit-wrapper">
            <div class="unit-header" slot="face">
              <div class="unitthumb">
                <div class="active"></div>
                <div class="thumb" :style="{ 'background-image': 'url(' + lesson.thumbnail + ')' }"></div>
              </div>
              <div class="unit-subtitle font17">レッスン{{ lessonIndex + 1 }}</div>
              <div class="todetail_sp" v-on:click="$emit('showLessonDetail', lessonIndex, unit)" />
              <div class="acTrigger"></div>
            </div>
            <div class="list" slot="content">
              <div>
                <div v-for="(path, pathIndex) in lesson.paths" v-on:click="$emit('startLessonForMobile', currentLevelNo, unit.unitNo, lessonIndex, pathIndex, getPathProgressIndex(unit.unitNo, lessonIndex, pathIndex))">
                  <div class="list-item">
                    <span v-if="getPathState(unit.unitNo, lessonIndex, pathIndex) === 'gone'" class="gone"></span>
                    <span v-else-if="getPathState(unit.unitNo, lessonIndex, pathIndex) === 'going'" class="going"></span>
                    <span v-else class="pending"></span>
                    <span class="lessontitle">{{ path.title }}</span>
                    <span class="sp-progress">進捗：{{ getPathProgress(unit.unitNo, lessonIndex, pathIndex) }}／{{ path.pathsteps.length }}</span>
                    <button type="button" v-if="getLessonProgress(unit.unitNo, lessonIndex) == pathIndex" class="sp-btn-lblue">レッスンを続ける</button>
                    <button type="button" v-if="getLessonProgress(unit.unitNo, lessonIndex) == -1 && pathIndex == 0" class="sp-btn-lblue">レッスンを今すぐ開始</button>
                  </div><!-- /.list-item -->
                </div>
              </div>
            </div><!-- /.list -->
          </popover><!-- /.popover -->
        </div>
      </div><!-- /.flexbox -->
    </div>
  </div><!-- /.inner -->
  <div class="inner" v-else>
    <!-- ユニットタイトル -->
    <h3 class="h3">ユニット{{ currentUnitJson.unitNo }} 「{{ currentUnitJson.title }}」</h3>

    <!-- ユニット詳細一覧 -->
    <div class="flexbox">
      <div v-for="(lesson, lessonIndex) in currentUnitJson.lessons" class="item">
        <div class="section">
          <div class="unit-header">
            <div class="unitthumb">
              <div class="active"></div>
              <div class="thumb" :style="{ 'background-image': 'url(' + lesson.thumbnail + ')' }"></div>
            </div>
            <div class="unit-subtitle font17">レッスン{{ lessonIndex + 1 }}</div>
          </div>
          <div class="list">
            <div>
              <div v-for="(path, pathIndex) in lesson.paths" v-on:click="$emit('clickLesson', lessonIndex, pathIndex)">
                <div class="list-item">
                  <span v-if="getPathState(currentUnitNo, lessonIndex, pathIndex) === 'gone'" class="gone"></span>
                  <span v-else-if="getPathState(currentUnitNo, lessonIndex, pathIndex) === 'going'" class="going"></span>
                  <span v-else class="pending"></span>
                  <span class="lessontitle">{{ path.title }}</span>
                </div><!-- /.list-item -->
              </div>
            </div>
            <button type="button" v-on:click="$emit('showLessonDetail', lessonIndex, '')" class="todetail">詳細を表示</button>
          </div><!-- /.list -->
        </div><!-- /.section -->
      </div>
    </div><!-- /.flexbox -->
  </div><!-- /.inner -->
</template>

<script>
import * as constants from '@/mixin/constants'
import * as storeConstants from '@/store/constants'
import common from '@/mixin/common'
import popover from 'vue-popover'

export default {
  name: 'homeunit',
  props: {
    currentLevelNo: Number,
    currentUnitNo: Number,
    currentUnitJson: Object,
    index: Number,
    currentLevelJson: Object,
    isDocomo: Boolean,
  },
  data: function() {
    return {
      isMobile: !this.isEnvironmentPc(),
      targetUnitIndex: 0, // タイトル固定対象を特定するためのインデックス
      prevScrollPosition: 0, // 前のユニットタイトル固定した際のスクロール量
      fixedScrollPosition: 0, // 現在のユニットタイトルを固定した際のスクロール量
      fixedUnitNo: this.currentLevelJson.units[0].unitNo, // 現在固定されているユニットのNo.
      fixedUnitTitle: this.currentLevelJson.units[0].title // 現在固定されているユニットのタイトル
   }
  },
  components: {
    popover
  },
  mixins: [
    common
  ],
  computed: {
    UnitIndexs: function() {
      var unitIndexs = [];
      var i = 0;
      while(i < this.currentLevelJson.units.length) {
        unitIndexs.push("Unit" + i );
        i ++;
      }
      return unitIndexs
    },
    LessonIndexs: function() {
      var lessonIndexs = [];
      var i = 0;
      while(i < this.currentLevelJson.units.length) {
      var j = 0;
      var lesson = []
        while(j < this.currentLevelJson.units[i].lessons.length) {
          lesson.push("Unit" + i + "_Lesson" + j)
          j ++;
        }
        lessonIndexs.push(lesson)
        i ++;
      }
      return lessonIndexs
    },
    topHeight: function() {
      // header(toolbar)の高さを取得
　　　　var headerHeight = document.getElementById("header").clientHeight;
      // 一番初めのUnitのclass="h3"の高さを取得
      var activeHeight = document.getElementById(this.UnitIndexs[0]).clientHeight;
      return headerHeight + activeHeight / 2
    },
  },
  methods: {
    /**
     * ステータスを取得
     *
     * @param {Number} unitNo ユニット番号
     * @param {Number} lessonIndex レッスンIndex
     * @param {Number} pathIndex PathIndex
     *
     * @return {String} 未着手の場合"go"、進行中の場合"going"、全問解答の場合"gone"を返却する
     */
    getPathState: function(unitNo, lessonIndex, pathIndex) {
      var res = 'go'

      var params = {levelNo: this.currentLevelNo, unitNo: unitNo, lessonIndex: lessonIndex, pathIndex: pathIndex}
      var lessonScore = this.$store.getters.path(params)
      switch (lessonScore.status) {
        case storeConstants.PATH_STATE_COMPLETED:
          res = 'gone'
          break
        case storeConstants.PATH_STATE_IN_PROGRESS:
          res = 'going'
          break
        default:
          break
      }

      return res
    },
    /**
     * 指定Pathの進捗を取得する
     *
     * @param {Number} unitNo ユニット番号
     * @param {Number} lessonIndex レッスンIndex
     * @param {Number} pathIndex PathIndex
     *
     * @return {Number} 指定Pathの進捗
     */
    getPathProgress: function(unitNo, lessonIndex, pathIndex) {
      var params = { levelNo: this.currentLevelNo, unitNo: unitNo, lessonIndex: lessonIndex, pathIndex: pathIndex }
      var pathstepIndex = this.$store.getters.filterProgress(params)
      return pathstepIndex < 0 ? 0 : pathstepIndex + 1
    },
    /**
     * 指定Pathの進捗(PathstepIndex)を取得する
     *
     * @param {Number} unitNo ユニット番号
     * @param {Number} lessonIndex レッスンIndex
     * @param {Number} pathIndex PathIndex
     *
     * @return {Number} 指定Pathの進捗(PathstepIndex)
     */
    getPathProgressIndex: function(unitNo, lessonIndex, pathIndex) {
      var params = { levelNo: this.currentLevelNo, unitNo: unitNo, lessonIndex: lessonIndex, pathIndex: pathIndex }
      var pathstepIndex = this.$store.getters.filterProgress(params)
      return 0 < pathstepIndex ? pathstepIndex : 0
    },
    /**
     * 指定レッスンの進捗を取得する
     *
     * @param {Number} unitNo ユニット番号
     * @param {Number} lessonIndex レッスンIndex
     *
     * @return {Number} 指定レッスンの進捗(PathIndex)
     */
    getLessonProgress: function(unitNo, lessonIndex) {
      var params = { levelNo: this.currentLevelNo, unitNo: unitNo, lessonIndex: lessonIndex }
      var progress = this.$store.getters.filterProgressByLessonIndex(params)
      if (!progress) {
        return -1
      }
      var progressDetails = this.splitProgress(progress)
      return progressDetails[3]
    },
    /**
     * スクロール検知時の処理
     */
    handleScroll: function(event) {

      var targetAddUnit = this.targetUnitIndex + 1
      var targetRemoveUnit = this.targetUnitIndex

      // 最後のUnitの場合は判定から除外
      if (targetRemoveUnit != this.currentLevelJson.units.length -1) {
　  　　　// activeクラスの追加判定
        var addTargetElement = document.getElementById(this.UnitIndexs[targetAddUnit]);
        var clientRect = addTargetElement.getBoundingClientRect();
        var clientY = clientRect.top
        this.unitTitleFixedPosition(addTargetElement, clientY);
      }

      // 最初のUnitの場合は判定から除外
      if (targetRemoveUnit != 0) {
        // activeクラスの削除判定
        var scrollY = window.pageYOffset
        var removeTargetElement = document.getElementById(this.UnitIndexs[targetRemoveUnit]);
        this.unitTitleunFixedPosition(removeTargetElement, scrollY);
      }

    },
    /**
     * Unitタイトルを固定する
     *
     * @param targetElement activeクラス追加対象のElement
     * @param clientY 固定対象のUnitタイトルのY座標
     */
　　　unitTitleFixedPosition: function(targetElement, clientY) {
      // class="h3"のy座標が画面上部に達したら、class="h3"内にclass="active"を追加
      if(clientY <= this.topHeight){
        this.targetUnitIndex += 1
        this.fixedUnitNo = this.currentLevelJson.units[this.targetUnitIndex].unitNo
        this.fixedUnitTitle = this.currentLevelJson.units[this.targetUnitIndex].title
        this.prevScrollPosition = this.fixedScrollPosition;
        this.fixedScrollPosition = window.pageYOffset;
      }
    },
    /**
     * Unitタイトルを非固定にする
     *
     * @param targetElement activeクラス削除対象のElement
     * @param clientY 固定しているUnitタイトルに含まれるレッスン（１つ目）のY座標
     */
     unitTitleunFixedPosition: function(targetElement, clientY) {

       // ユニットタイトルを固定した際のスクロールより上ににスクロールされた場合は、class="active"を削除
       if(clientY < this.fixedScrollPosition) {
         this.targetUnitIndex -= 1
         this.fixedUnitNo = this.currentLevelJson.units[this.targetUnitIndex].unitNo
         this.fixedUnitTitle = this.currentLevelJson.units[this.targetUnitIndex].title
         this.fixedScrollPosition = this.prevScrollPosition
      }
    },
    /**
     * Docomo版Androidアプリの場合
     * 固定されるユニットタイトル、レッスン一覧の高さを変更する
     */
    styleChange: function() {
      if(this.isDocomo) {
        // wifi推奨文言の高さを取得
        var obj = document.getElementById('wifi-message');
        var divHeight = obj.offsetHeight;
        
        // 固定ユニット名の位置変更
        var header = parseInt($("div.wifi-message").css("top"));
        var result = header + divHeight;
        $("h3.active").css("top", result);

        // レッスンリストの初期表示位置を変更する
        var lessonRes = result + header;
        $(".slick-slider >div:first-child").css("padding-top", lessonRes);
      }
    },
  },
  mounted: function() {
    this.log("HomeUnit start mounted")
    if(!this.isEnvironmentPc()) {
      this.styleChange();
      // スクロールを検知する
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  watch: {
    currentLevelNo: function(newLevelNo) {
      this.log("HomeUnit watch currentLevelNo")

      this.targetUnitIndex = 0
      this.prevScrollPosition = 0
      this.fixedScrollPosition = 0
      this.fixedUnitNo = this.currentLevelJson.units[0].unitNo
      this.fixedUnitTitle = this.currentLevelJson.units[0].title
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/style/home';
</style>



// WEBPACK FOOTER //
// HomeUnit.vue?e404ad24